module.exports = __webpack_public_path__ + "img/1723013664534-WhatsApp Image 2024-08-07 at 14.47.35.jpeg.862e9df9.webp";